import { TreePanel } from '../molecules/TreePanel';
import { MainGrid } from '../molecules/MainGrid';
import { EnergyColumnVisibility } from '../EnergyColumnDefinitions';
import { ActorTree } from '../../types/actor-types';
import { SiteNode } from '../../types/types';

interface DashboardContentProps {
  isTreeViewVisible: boolean;
  isResizing: boolean;
  treeViewWidth: number;
  operatorTreeActors: ActorTree[];
  selectedLocationActorId: string;
  shouldAutoScrollTree: boolean;
  onLocationSelect: (actorId: string) => void;
  onTreeResize: (e: React.MouseEvent) => void;
  siteManagementData: SiteNode[];
  hierarchicalSiteData: any[];
  columnVisibility: EnergyColumnVisibility;
  isLoading?: boolean;
  selectedChargingStatuses?: string[];
  selectedAllocatedRanges?: string[];
  hideInactive?: boolean;
  viewMode?: 'single' | 'operator';
  onSessionClick?: (sessionId: string | null, machineName?: string, machineId?: number) => void;
  unitMode?: 'A' | 'kW';
  onLoadMore?: () => void;
  hasMore?: boolean;
  isLoadingMore?: boolean;
}

export function DashboardContent({
  isTreeViewVisible,
  isResizing,
  treeViewWidth,
  operatorTreeActors,
  selectedLocationActorId,
  shouldAutoScrollTree,
  onLocationSelect,
  onTreeResize,
  siteManagementData,
  hierarchicalSiteData,
  columnVisibility,
  isLoading = false,
  selectedChargingStatuses = [],
  selectedAllocatedRanges = [],
  hideInactive = false,
  viewMode = 'single',
  onSessionClick,
  unitMode = 'A',
  onLoadMore,
  hasMore = false,
  isLoadingMore = false,
}: DashboardContentProps) {
  return (
    <div className="flex relative">
      <TreePanel
        isVisible={isTreeViewVisible}
        isResizing={isResizing}
        width={treeViewWidth}
        actors={operatorTreeActors}
        selectedLocationId={selectedLocationActorId}
        shouldAutoScroll={shouldAutoScrollTree}
        onLocationSelect={onLocationSelect}
        onResize={onTreeResize}
      />

      <MainGrid
        data={siteManagementData}
        columnVisibility={columnVisibility}
        selectedActorId={selectedLocationActorId || undefined}
        isTreeViewVisible={isTreeViewVisible}
        isResizing={isResizing}
        isLoading={isLoading}
        selectedChargingStatuses={selectedChargingStatuses}
        selectedAllocatedRanges={selectedAllocatedRanges}
        hideInactive={hideInactive}
        viewMode={viewMode}
        onSessionClick={onSessionClick}
        unitMode={unitMode}
        onLoadMore={onLoadMore}
        hasMore={hasMore}
        isLoadingMore={isLoadingMore}
      />
    </div>
  );
}
